import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LoanDocumentNavSF from '../../../components/superUser/loan/LoanDocumentNavSF.js'
import LoanDocumentSubNavSF from '../../../components/superUser/loan/LoanDocumentSubNavSF.js'
import MasterTemplateTermSF from '../../../components/superUser/settings/masterTemplates/MasterTemplateTermSF.js'

const PersonalGuaranteeGeneralTermsPageUI = ({ context, errorList, loan, template, onRefreshClick }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ftl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!template || !errorList} loan={loan} page='loanDoc'
    dimension='w1600'
  >
    {
      (!template || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      template &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Loan documents</b></span>
            </span>
          }
          right={<span />}
        />

        <LoanDocumentNavSF context={context} loan={loan} documentType='personalGuarantee' />
        <LoanDocumentSubNavSF
          context={context}
          loan={loan}
          documentCode='personal_guarantee_2'
          basePath='personalGuarantee'
          page='general'
          onRefreshClick={onRefreshClick}
        />

        <MasterTemplateTermSF
          context={context}
          loan={loan}
          title='General terms'
          templateCode='personal_guarantee_general'
          templateTerm={template}
          onRefreshClick={onRefreshClick}
        />

      </div>
    }
  </SuperUserLoanPageUI>

export default PersonalGuaranteeGeneralTermsPageUI

